import React from "react";
import {View, StyleSheet, Text} from "react-native";
import {globalFontStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import {Input} from "../../../components/core/Input";
import {useForm} from "react-hook-form";
import FastImage from "../../../common/FastImage";
import {warning} from "../../../utils/images";

const ManualCouponBlk = ({onPromoApply, isError, isBottomSheet}) => {
  const {
    control: controlPromo,
    formState: {isValid: isValid2},
    handleSubmit: handleSubmitPromo,
    watch: watchPromo,
  } = useForm({
    mode: "onChange",
  });
   
  const watchPromoCode = watchPromo("promoCode");

  const onApply = () => {
    onPromoApply(watchPromoCode, true);
  };

  return (
    <View style={styles.container}>
      <Input
        name="promoCode"
        control={controlPromo}
        label="Enter Promo Code (if any)"
        variant={isError ? "error" : "default"}
        size="default"
        placeholder="eg: TRADEX50"
        rules={{
          required: "Please enter a valid promo code",
        }}
        button={{
          text: "Apply",
          onPress: handleSubmitPromo(onApply),
          disabled: !isValid2,
          variant: "text",
          style: styles.applyButton,
          textStyle: styles.applyButtonText
        }}
        containerStyle={{
          marginTop: isBottomSheet ? 5 : 15,
        }}
        hideError={true}
      />
      
      {typeof isError === 'string' && isError.length > 0 && (
        <View style={styles.errorContainer}>
          <FastImage
            style={styles.warningIcon}
            source={warning()}
          />
          <Text style={styles.errorText}>
            {isError}
          </Text>
        </View>
      )}
    </View>
  );
};

export default ManualCouponBlk;

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  applyButton: {
    height: 32,
    paddingHorizontal: 12,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 8,
    borderWidth: 0,
  },
  applyButtonText: {
    ...globalFontStyle.appFontSubText,
    color: Colors.tradexBlue,
  },
  errorContainer: {
    flexDirection: "row",
    marginBottom: 10,
    marginTop: 4,
    alignItems: 'center',
  },
  warningIcon: {
    width: 15,
    height: 15,
  },
  errorText: {
    ...globalFontStyle.appFontSubText,
    marginLeft: 5,
    color: Colors.red,
  }
});
